import React, {createContext, useContext, useState} from "react";
import {getBaskets} from "./crud/basketCrud";

const BasketsUIContext = createContext();

export function useBasketsUIContext() {
    return useContext(BasketsUIContext);
}

export function BasketsUIProvider({children}) {

    const [id, setId] = useState(0);
    const [data, setData] = useState({});
    const [basket, setBasket] = useState({});
    const [openEdit, setOpenEdit] = useState(false);
    const [openDelete, setOpenDelete] = useState(false);
    const [openError, setOpenError] = useState(false);
    const [error, setError] = useState('');

    const fetchData = (page, limit) => {
        getBaskets(page, limit)
            .then((response) => {
                setData(response.data.data);
            }).catch(err => console.log(err));
    };

    const handleEdit = id => {
        setOpenEdit(true);
        setId(id);
    };

    const handleDelete = id => {
        setOpenDelete(true);
        setId(id);
    };

    const value = {
        data,
        setData,
        basket,
        setBasket,
        openError,
        setOpenError,
        error,
        setError,
        openEdit,
        setOpenEdit,
        openDelete,
        setOpenDelete,
        id,
        setId,
        handleDelete,
        handleEdit,
        fetchData,
    };

    return <BasketsUIContext.Provider value={value}>{children}</BasketsUIContext.Provider>;
}